import React, { useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { PAGES_MENU_DISPLAY_COUNT } from '../../constants/admin';
import useSearchablePages from '../hooks/useSearchablePages';
import FormFieldPageSelect from '../components/FormFieldPageSelect';
import DraftToggle from '../components/DraftToggle';
import {
  BLOG_CATEGORY_PAGE,
  BLOG_HOME_PAGE,
  BLOG_PAGE,
  FACILITY_LINK,
  FACILITY_LISTING,
} from '../../data/db/lib/typeCodes';

const excludeTypes = [
  BLOG_CATEGORY_PAGE,
  BLOG_HOME_PAGE,
  BLOG_PAGE,
  FACILITY_LINK,
  FACILITY_LISTING,
];

const GET_PAGES = gql`
  query GetBreadcrumbTrailsPages(
    $excludeIds: [ID!],
    $excludeTypes: [String!],
    $first: Int!,
    $fulltext: String,
    $locale: String!,
    $live: Boolean
  ) {
    pages(filter: {
      excludeIds: $excludeIds,
      excludeTypes: $excludeTypes,
      fulltext: $fulltext,
      locale: $locale,
      live: $live
    }, first: $first) {
      ...BreadcrumbParentPageDropdownPagesConnection
    }
  }
  ${FormFieldPageSelect.fragments.pagesConnection.breadcrumbs}
`;

const propTypes = {
  locale: PropTypes.string.isRequired,
  excludeIds: PropTypes.arrayOf(PropTypes.string),
  parentPage: PropTypes.shape({
    title: PropTypes.string,
    internalName: PropTypes.string,
  }),
};

const defaultProps = {
  excludeIds: [],
  parentPage: undefined,
};

const BreadcrumbParentPageDropdown = ({
  locale,
  parentPage,
  excludeIds,
  ...rest
}) => {
  const [showDrafts, setShowDrafts] = useState(true);

  const [state, { onChange }] = useSearchablePages(
    GET_PAGES,
    ({ fulltext }) => ({
      variables: {
        excludeIds,
        excludeTypes,
        first: 10,
        fulltext,
        locale,
        live: showDrafts ? null : true,
      },
    }),
    [locale, excludeIds, showDrafts],
  );

  const toggleShowDrafts = () => setShowDrafts(!showDrafts);

  const { error, loading, pages, totalCount } = state;

  const enableSearch = totalCount > PAGES_MENU_DISPLAY_COUNT;
  if (error) {
    return (
      <FormFieldPageSelect
        placeholder="There was an issue..."
        disabled
        {...rest}
      />
    );
  }

  return (
    <React.Fragment>
      <FormFieldPageSelect
        loading={loading}
        pages={pages}
        onSearch={onChange}
        searchable={enableSearch}
        resetValue={parentPage}
        showDrafts={showDrafts}
        {...rest}
      />
      <DraftToggle showDrafts={showDrafts} toggleShowDrafts={toggleShowDrafts} />
    </React.Fragment>
  );
};

BreadcrumbParentPageDropdown.propTypes = propTypes;
BreadcrumbParentPageDropdown.defaultProps = defaultProps;

export default BreadcrumbParentPageDropdown;
